/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BroadcastMessage } from '../model/broadcastMessage';
import { CreateBroadcastMessageDto } from '../model/createBroadcastMessageDto';
import { DeliverySystemMessageLog } from '../model/deliverySystemMessageLog';
import { GetBroadcastMessageDto } from '../model/getBroadcastMessageDto';
import { ResponseDTO } from '../model/responseDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BroadcastMessageService {

    protected basePath = 'http://10.1.1.123:30118';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param createBroadcastMessageDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public broadcastMessageCreate(createBroadcastMessageDto: CreateBroadcastMessageDto, observe?: 'body', reportProgress?: boolean): Observable<ResponseDTO>;
    public broadcastMessageCreate(createBroadcastMessageDto: CreateBroadcastMessageDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseDTO>>;
    public broadcastMessageCreate(createBroadcastMessageDto: CreateBroadcastMessageDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseDTO>>;
    public broadcastMessageCreate(createBroadcastMessageDto: CreateBroadcastMessageDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (createBroadcastMessageDto === null || createBroadcastMessageDto === undefined) {
            throw new Error('Required parameter createBroadcastMessageDto was null or undefined when calling broadcastMessageCreate.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResponseDTO>(`${this.basePath}/api/BroadcastMessage/Create`,
            createBroadcastMessageDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public broadcastMessageGetByServiceProviderId(serviceProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastMessage>>;
    public broadcastMessageGetByServiceProviderId(serviceProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastMessage>>>;
    public broadcastMessageGetByServiceProviderId(serviceProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastMessage>>>;
    public broadcastMessageGetByServiceProviderId(serviceProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<BroadcastMessage>>(`${this.basePath}/api/BroadcastMessage/GetByServiceProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param deliveryStatus 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public broadcastMessageGetByServiceProviderIdAndDeliveryStatus(serviceProviderId?: string, deliveryStatus?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastMessage>>;
    public broadcastMessageGetByServiceProviderIdAndDeliveryStatus(serviceProviderId?: string, deliveryStatus?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastMessage>>>;
    public broadcastMessageGetByServiceProviderIdAndDeliveryStatus(serviceProviderId?: string, deliveryStatus?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastMessage>>>;
    public broadcastMessageGetByServiceProviderIdAndDeliveryStatus(serviceProviderId?: string, deliveryStatus?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (deliveryStatus !== undefined && deliveryStatus !== null) {
            queryParameters = queryParameters.set('deliveryStatus', <any>deliveryStatus);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<BroadcastMessage>>(`${this.basePath}/api/BroadcastMessage/GetByServiceProviderIdAndDeliveryStatus`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param messageType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public broadcastMessageGetByServiceProviderIdAndMessageType(serviceProviderId?: string, messageType?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastMessage>>;
    public broadcastMessageGetByServiceProviderIdAndMessageType(serviceProviderId?: string, messageType?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastMessage>>>;
    public broadcastMessageGetByServiceProviderIdAndMessageType(serviceProviderId?: string, messageType?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastMessage>>>;
    public broadcastMessageGetByServiceProviderIdAndMessageType(serviceProviderId?: string, messageType?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (messageType !== undefined && messageType !== null) {
            queryParameters = queryParameters.set('messageType', <any>messageType);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<BroadcastMessage>>(`${this.basePath}/api/BroadcastMessage/GetByServiceProviderIdAndMessageType`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param deliveryStatus 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public broadcastMessageGetByServiceProviderIdAndNotDeliveryStatus(serviceProviderId?: string, deliveryStatus?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastMessage>>;
    public broadcastMessageGetByServiceProviderIdAndNotDeliveryStatus(serviceProviderId?: string, deliveryStatus?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastMessage>>>;
    public broadcastMessageGetByServiceProviderIdAndNotDeliveryStatus(serviceProviderId?: string, deliveryStatus?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastMessage>>>;
    public broadcastMessageGetByServiceProviderIdAndNotDeliveryStatus(serviceProviderId?: string, deliveryStatus?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (deliveryStatus !== undefined && deliveryStatus !== null) {
            queryParameters = queryParameters.set('deliveryStatus', <any>deliveryStatus);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<BroadcastMessage>>(`${this.basePath}/api/BroadcastMessage/GetByServiceProviderIdAndNotDeliveryStatus`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param messageType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public broadcastMessageGetByServiceProviderIdAndNotMessageType(serviceProviderId?: string, messageType?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastMessage>>;
    public broadcastMessageGetByServiceProviderIdAndNotMessageType(serviceProviderId?: string, messageType?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastMessage>>>;
    public broadcastMessageGetByServiceProviderIdAndNotMessageType(serviceProviderId?: string, messageType?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastMessage>>>;
    public broadcastMessageGetByServiceProviderIdAndNotMessageType(serviceProviderId?: string, messageType?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (messageType !== undefined && messageType !== null) {
            queryParameters = queryParameters.set('messageType', <any>messageType);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<BroadcastMessage>>(`${this.basePath}/api/BroadcastMessage/GetByServiceProviderIdAndNotMessageType`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param getBroadcastMessageDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public broadcastMessageGetByServiceProviderIdMessageTypeDeliveryStatusDateRange(getBroadcastMessageDto: GetBroadcastMessageDto, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastMessage>>;
    public broadcastMessageGetByServiceProviderIdMessageTypeDeliveryStatusDateRange(getBroadcastMessageDto: GetBroadcastMessageDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastMessage>>>;
    public broadcastMessageGetByServiceProviderIdMessageTypeDeliveryStatusDateRange(getBroadcastMessageDto: GetBroadcastMessageDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastMessage>>>;
    public broadcastMessageGetByServiceProviderIdMessageTypeDeliveryStatusDateRange(getBroadcastMessageDto: GetBroadcastMessageDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (getBroadcastMessageDto === null || getBroadcastMessageDto === undefined) {
            throw new Error('Required parameter getBroadcastMessageDto was null or undefined when calling broadcastMessageGetByServiceProviderIdMessageTypeDeliveryStatusDateRange.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<BroadcastMessage>>(`${this.basePath}/api/BroadcastMessage/GetByServiceProviderIdMessageTypeDeliveryStatusDateRange`,
            getBroadcastMessageDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param getBroadcastMessageDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public broadcastMessageGetByServiceProviderIdMessageTypeNotDeliveryStatusDateRange(getBroadcastMessageDto: GetBroadcastMessageDto, observe?: 'body', reportProgress?: boolean): Observable<Array<BroadcastMessage>>;
    public broadcastMessageGetByServiceProviderIdMessageTypeNotDeliveryStatusDateRange(getBroadcastMessageDto: GetBroadcastMessageDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BroadcastMessage>>>;
    public broadcastMessageGetByServiceProviderIdMessageTypeNotDeliveryStatusDateRange(getBroadcastMessageDto: GetBroadcastMessageDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BroadcastMessage>>>;
    public broadcastMessageGetByServiceProviderIdMessageTypeNotDeliveryStatusDateRange(getBroadcastMessageDto: GetBroadcastMessageDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (getBroadcastMessageDto === null || getBroadcastMessageDto === undefined) {
            throw new Error('Required parameter getBroadcastMessageDto was null or undefined when calling broadcastMessageGetByServiceProviderIdMessageTypeNotDeliveryStatusDateRange.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<BroadcastMessage>>(`${this.basePath}/api/BroadcastMessage/GetByServiceProviderIdMessageTypeNotDeliveryStatusDateRange`,
            getBroadcastMessageDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public broadcastMessageGetFromDeliverySystem(serviceProviderId?: number, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<DeliverySystemMessageLog>>;
    public broadcastMessageGetFromDeliverySystem(serviceProviderId?: number, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DeliverySystemMessageLog>>>;
    public broadcastMessageGetFromDeliverySystem(serviceProviderId?: number, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DeliverySystemMessageLog>>>;
    public broadcastMessageGetFromDeliverySystem(serviceProviderId?: number, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<DeliverySystemMessageLog>>(`${this.basePath}/api/BroadcastMessage/GetFromDeliverySystem`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param createBroadcastMessageDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public broadcastMessageRetry(createBroadcastMessageDto: CreateBroadcastMessageDto, observe?: 'body', reportProgress?: boolean): Observable<ResponseDTO>;
    public broadcastMessageRetry(createBroadcastMessageDto: CreateBroadcastMessageDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseDTO>>;
    public broadcastMessageRetry(createBroadcastMessageDto: CreateBroadcastMessageDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseDTO>>;
    public broadcastMessageRetry(createBroadcastMessageDto: CreateBroadcastMessageDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (createBroadcastMessageDto === null || createBroadcastMessageDto === undefined) {
            throw new Error('Required parameter createBroadcastMessageDto was null or undefined when calling broadcastMessageRetry.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ResponseDTO>(`${this.basePath}/api/BroadcastMessage/Retry`,
            createBroadcastMessageDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
